var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section-login" }, [
    _c("div", { class: [_vm.$mq.phone ? "bg-white" : "bg-gray"] }, [
      _c("section", { staticClass: "container content-padding" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 p-0" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-sm-8 offset-sm-2 col-xl-6 offset-xl-3 col-12 p-0"
                },
                [
                  _c("div", { class: { "card py-3": !_vm.$mq.phone } }, [
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        class: { "card-body": !_vm.$mq.phone }
                      },
                      [
                        _vm.user === null && !_vm.registerSuccessFromPage
                          ? [
                              _vm.referralCode
                                ? _c("div", [
                                    _c("img", {
                                      staticClass: "rounded-circle mb-4",
                                      attrs: {
                                        src: _vm.referralCodeOwner.picture,
                                        width: "80"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("h3", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "message.invite_friends.invite_friends_title",
                                            {
                                              name:
                                                _vm.referralCodeOwner.firstname,
                                              registerCredits:
                                                _vm.globalState.configData
                                                  .register_credits
                                            }
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.invite_friends.invite_friends_detail",
                                              {
                                                name:
                                                  _vm.referralCodeOwner
                                                    .firstname,
                                                credits:
                                                  _vm.globalState.configData
                                                    .invite_friend_credits,
                                                registerCredits:
                                                  _vm.globalState.configData
                                                    .register_credits
                                              }
                                            )
                                          ) +
                                          "\n                      "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "my-4" }, [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "message.invite_friends.sign_up_to_claim_your_credits"
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("register-form", {
                                attrs: { registerFrom: "registerPage" }
                              })
                            ]
                          : [
                              _c(
                                "div",
                                { staticClass: "text-center" },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fal fa-check-circle fa-4x text-success mb-4"
                                  }),
                                  _vm._v(" "),
                                  _c("h2", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.register.register_success"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "mb-4" }, [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "message.register.register_success_detail"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "btn btn-primary -cyan",
                                      attrs: { tag: "button", to: "/" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.register.register_btn_done"
                                            )
                                          ) +
                                          "\n                      "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("br"),
                                  _c("br")
                                ],
                                1
                              )
                            ]
                      ],
                      2
                    )
                  ])
                ]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10c2b554", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10c2b554","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/Index.vue
// module id = 2145
// module chunks = 0